(function () {
  'use strict';

  /* ── Salesforce reCAPTCHA timestamp (required by WebToLead) ── */
  setInterval(function () {
    document.querySelectorAll('[name="captcha_settings"]').forEach(function (field) {
      try {
        var data = JSON.parse(field.value);
        data.ts = String(new Date().getTime());
        field.value = JSON.stringify(data);
      } catch (e) {}
    });
  }, 500);

  /* ── Helpers ── */
  function isValidEmail(val) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
  }

  function showError(field, message) {
    field.classList.add('cf-field--error');
    /* remove any existing error first */
    var existing = field.parentNode.querySelector('.cf-error-msg[data-for="' + field.name + '"]');
    if (existing) existing.remove();
    var err = document.createElement('span');
    err.className = 'cf-error-msg';
    err.setAttribute('role', 'alert');
    err.setAttribute('data-for', field.name);
    err.textContent = message;
    field.insertAdjacentElement('afterend', err);
  }

  function showErrorAfterEl(el, id, message) {
    var existing = document.querySelector('.cf-error-msg[data-for="' + id + '"]');
    if (existing) existing.remove();
    var err = document.createElement('span');
    err.className = 'cf-error-msg';
    err.setAttribute('role', 'alert');
    err.setAttribute('data-for', id);
    err.textContent = message;
    el.insertAdjacentElement('afterend', err);
  }

  function clearFieldError(field) {
    field.classList.remove('cf-field--error');
    var err = field.parentNode.querySelector('.cf-error-msg[data-for="' + field.name + '"]');
    if (err) err.remove();
  }

  function clearAllErrors(form) {
    form.querySelectorAll('.cf-error-msg').forEach(function (el) { el.remove(); });
    form.querySelectorAll('.cf-field--error').forEach(function (el) { el.classList.remove('cf-field--error'); });
  }

  function getLabel(field) {
    var p = field.getAttribute('placeholder');
    if (p) return p;
    if (field.tagName === 'SELECT') return 'This field';
    return 'This field';
  }

  function getRecaptchaToken(form) {
    if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.getResponse === 'function') {
      var box = form.querySelector('.g-recaptcha');
      if (box && box.dataset.widgetId !== undefined) {
        return grecaptcha.getResponse(parseInt(box.dataset.widgetId, 10));
      }
      return grecaptcha.getResponse();
    }
    var ta = form.querySelector('textarea[name="g-recaptcha-response"]');
    return ta ? ta.value.trim() : '';
  }

  /* ── Per-form init ── */
  function initForm(wrapper) {
    var form = wrapper.querySelector('form');
    if (!form || form.dataset.cfInit) return;
    form.dataset.cfInit = '1';

    /* Take full control — disable native browser bubbles */
    form.setAttribute('novalidate', '');

    form.addEventListener('submit', function (e) {
      /* Always block first, validate, then decide */
      e.preventDefault();
      clearAllErrors(form);

      var valid = true;
      var firstInvalid = null;

      /* Validate all required fields */
      form.querySelectorAll('input[required], select[required], textarea[required]').forEach(function (field) {
        /* skip hidden fields */
        if (field.type === 'hidden') return;

        var val = field.value.trim();
        var error = '';

        if (!val) {
          error = getLabel(field) + ' is required.';
        } else if (field.type === 'email' && !isValidEmail(val)) {
          error = 'Please enter a valid email address.';
        }

        if (error) {
          showError(field, error);
          if (!firstInvalid) firstInvalid = field;
          valid = false;
        }
      });

      /* Validate reCAPTCHA */
      var recaptchaBox = form.querySelector('.g-recaptcha');
      if (recaptchaBox) {
        var token = getRecaptchaToken(form);
        if (!token) {
          showErrorAfterEl(recaptchaBox, 'recaptcha', 'Please verify you are not a robot.');
          if (!firstInvalid) firstInvalid = recaptchaBox;
          valid = false;
        }
      }

      if (!valid) {
        if (firstInvalid) {
          firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (typeof firstInvalid.focus === 'function') firstInvalid.focus();
        }
        return;
      }

      /* All good — submit bypassing the listener */
      form.submit();
    });

    /* Clear per-field errors as the user types / changes */
    form.querySelectorAll('input, select, textarea').forEach(function (field) {
      ['input', 'change'].forEach(function (evt) {
        field.addEventListener(evt, function () { clearFieldError(field); });
      });
    });
  }

  /* ── Init all contact forms on the page ── */
  function init() {
    document.querySelectorAll('[contact-form-js]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

